import React, { useState, memo, useRef, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav'
// import NavLink from 'react-bootstrap/NavLink'
import NavItem from 'react-bootstrap/NavItem'
import Tab from 'react-bootstrap/Tab'
import TabPane from 'react-bootstrap/TabPane'
import TabContent from 'react-bootstrap/TabContent'
import PropTypes from 'prop-types'
import './MegaMenu.scss'
import { useSelector } from 'react-redux'
import { MdArrowForwardIos } from 'react-icons/md'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const MegaMenu = (props) => {
  const [tab, setTab] = useState()
  const { loading, data } = useSelector((state) => state.categories)
  const [show, setShow] = useState([])
  const showCategory = (k, item) => {
    setShow(item)
    setTab(k)
  }


  const categoriesImages = {
    filters: '/image/icon-filters.png',
    belts: '/image/icon-belts.png',
    brakes: '/image/icon-brakes.png',
    chemicals: '/image/icon-chemicals.png',
    lighting: '/image/icon-lighting.png',
    lubricants: '/image/icon-lubricants.png',
    'other-products': '/image/icon-miscellaneous.png',
    ppe: '/image/icon-ppe.png',
    'shop-supplies': '/image/icon-supplies.png',
    'tire-service': '/image/icon-tires.png',
    'wiper-blades': '/image/icon-wipers.png'
  }

  const subCategoriesImages = {
    filters: {
      'oil-filter': '/image/Filters/oil-filters-icon.png',
      'air-filter': '/image/Filters/air-filters-icon.png',
      'cabin-air-filter': '/image/Filters/cabin-air-filter-icon.png',
      'fuel-filter': '/image/Filters/fuel-filters-icon.png',
      transmission: '/image/Filters/transmission-filters-icon.png',
      'drain-plugs-and-gaskets': '/image/Miscellaneous/drain-plugs-gaskets-icon.png',
      'oil-filter-housing-caps': '/image/Miscellaneous/oil-caps-icon.png',
      tools: '/image/Filters/filter-tools.png'
    },
    belts: {
      'tensioner-or-pulley': '/image/Belts/belt-tensioner-icon.png',
      belts: '/image/Belts/belts-icon.png'
    },
    brakes: {
      'brake-pad-set': '/image/Brakes/brake-pads-icon.png',
      'parking-brake': '/image/Brakes/parking-brake-icon.png',
      'hub-bearings': '/image/Brakes/hub-bearings-icon.png',
      'brake-drum-and-rotor': '/image/Brakes/brake-drum-icon.png',
      'brake-shoe-set': '/image/Brakes/brake-shoes-icon.png'
    },
    chemicals: {
      aerosol: '/image/Chemicals/aerosols-icon.png',
      'air-conditioning': '/image/Chemicals/cooling-icon.png',
      brakes: '/image/Chemicals/brake-fluid-icon.png',
      cooling: '/image/Chemicals/cooling-icon 2.png',
      fuel: '/image/Chemicals/fuel-icon.png',
      maintenance: '/image/Chemicals/maintenance-icon.png',
      oil: '/image/Chemicals/oil-icon.png',
      'power-steering': '/image/Chemicals/power-streering-icon.png',
      transmission: '/image/Chemicals/transmission-icon.png'
    },
    lighting: {
      'halogen-capsules': '/image/Lighting/halogen-capsules-icon.png',
      led: '/image/Lighting/LED-icon.png',
      'minature-bulbs': '/image/Lighting/miniature-bulb-icon.png',
      'sealed-beams': '/image/Lighting/sealed-beam-icon.png'
    },
    lubricants: {
      'gear-oil': '/image/Lubricants/gear-oil-icon.png',
      grease: '/image/Lubricants/grease-icon.png',
      'motor-oil': '/image/Lubricants/motor-oil-icon.png'
    },
    'other-products': {
      'air-filter-hardware': '/image/Miscellaneous/hardware-icon.png',
      'cabin-filter-hardware': '/image/Miscellaneous/hardware-icon.png',
      'drain-plugs-and-gaskets': '/image/Miscellaneous/drain-plugs-gaskets-icon.png',
      'fuel-caps': '/image/Miscellaneous/fuel-caps-icon.png',
      'fuel-filter-hardware': '/image/Miscellaneous/hardware-icon.png',
      'hose-clamps': '/image/Miscellaneous/hose-clamps-icon.png',
      'oil-caps': '/image/Miscellaneous/oil-cap-icon.png',
      'oil-filter-housing-caps': '/image/Miscellaneous/oil-caps-icon.png',
      'radiator-caps': '/image/Miscellaneous/radiator-cap-icon.png',
      'gloves': '/image/PPE/gloves-icon.png',
      'air-fresheners': '/image/Filters/air-freshner.png',
      'tools': '/image/Miscellaneous/tools-new.png'
    },
    ppe: {
      cleaners: '/image/PPE/cleaners-icon.png',
      facial: '/image/PPE/facial-icon.png',
      gloves: '/image/PPE/gloves-icon.png',
      'vehicle-protection': '/image/PPE/vehicle-protection-icon.png'
    },
    'shop-supplies': {
      breakroom: '/image/Shop Supplies/break-room-icon.png',
      janitorial: '/image/Shop Supplies/janitorial-icon.png',
      office: '/image/Shop Supplies/office-icon.png',
      restroom: '/image/Shop Supplies/restroom-icon.png',
      safety: '/image/Shop Supplies/safety-icon.png'
    },
    'tire-service': {
      'balancing-beads': '/image/Tire Service/balancing-beads-icon.png',
      tpms: '/image/Tire Service/tpms-icon.png',
      'tpms-tools': '/image/Tire Service/tpms-tools-icon.png',
      'tire-chemicals': '/image/Tire Service/tire-chemicals-icon.png',
      'tire-repair': '/image/Tire Service/tire-repair-icon.png',
      'tire-repair-tools': '/image/Tire Service/tire-repair-tool-icon.png',
      'wheel-weight-tools': '/image/Tire Service/tire-weight-tool-icon.png',
      'wheel-weights': '/image/Tire Service/wheel-weight-icon.png'
    },
    'wiper-blades': {
      'rear-wiper-blade': '/image/Wiper Blades/rear-blade.png',
      'wiper-blades': '/image/Wiper Blades/wiper-blades-icon.png'
    }

  }


  // -----------------------------Scroll sub-menu content to start position after revisit to mega-menu-----------------
  const megaMenuRef = useRef(null)

  useEffect(() => {
    megaMenuRef.current.scrollLeft = 0
  }, [props?.toggleMegaMenu])


  return (
    <React.Fragment>
      <div className="mega_menu_container" ref={props.closeMegaMenu}>
        <Tab.Container defaultActiveKey={tab}>
          <div
            className={
              props.toggleMegaMenu ? 'mega-menu mega-menu-active' : 'mega-menu'
            }
          >
            <Nav className="mega_menu-categories d-flex" pills="true">
              {
                (!loading && data.length > 0)
                  ? (
                    <>
                      {
                        data?.map((category, j) => {
                          return (
                            <div className='mega-menu-single-category' key={j}>
                              <NavItem
                                className={`mega_menu-category ${tab === j && 'mega_menu-category-active'
                                  }`}
                                onClick={(e, item = category, k = j) => {
                                  showCategory(k, item)
                                }}
                              >
                                <Nav.Link eventKey={j}>
                                  <LazyLoadImage effect="blur"
                                    src={categoriesImages[category?.slug]}
                                    alt="Filters"
                                    width="56"
                                    height="35"
                                    className="mega_menu-category-image"
                                  />
                                  <p className="m-0 text-uppercase">{category?.categoryName}</p>
                                </Nav.Link>
                              </NavItem>
                            </div>
                          )
                        })
                      }
                    </>
                  )
                  : ''
              }
            </Nav>
            <TabContent>
              <TabPane eventKey={tab}>
                <div ref={megaMenuRef} className='megamenu-container'>
                  {
                    show?.children?.map((items, j) => {
                      return (
                        <div key={j} style={{ maxWidth: '200px' }} className="border-right">
                          <div className="mega_menu-category-filter" onClick={props.exitMegaMenu}>
                            <Link to={`/${show.slug}/${items.slug}`} className='mega_menu-category-filter'>
                              <LazyLoadImage effect="blur"
                                src={subCategoriesImages[show.slug][items.slug]}
                                alt="Filters"
                                //  height={80}
                                width={100}
                                style={{ objectFit: 'contain' }}
                                className="mega_menu-oil-img default-image-hover"
                              />
                              <div className='text-uppercase font-weight-bold'>
                                {items?.subCategoryName}
                              </div>
                            </Link>
                          </div>
                        </div>
                      )
                    })}
                </div>
                <div className="view-filter-container">
                  <div onClick={props.exitMegaMenu} className='view-filter-cont'>
                    <Link to={`/${show.slug}`} className="view-filter-container" >
                      <span className='text-uppercase'>VIEW ALL {show.categoryName}</span>
                    </Link>
                    <MdArrowForwardIos className="mega_menu-right-arrow" />
                  </div>
                </div>

              </TabPane>
            </TabContent>
          </div>
        </Tab.Container>
      </div>
    </React.Fragment>
  )
}

MegaMenu.propTypes = {
  closeMegaMenu: PropTypes.any,
  toggleMegaMenu: PropTypes.any,
  exitMegaMenu: PropTypes.func
}

export default memo(MegaMenu)
